'use client';

/**
 * Click Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { HowSoftwareWorksSection } from '../common/how-software-works-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { CommissionsSection } from '../common/commissions-section';
import { AdvantagesSection } from '../common/advantages-section';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';
import { TrendingUp, Zap, Layers, Award, Users, Crown } from 'lucide-react';

interface MLMPlan {
    slug: string;
    name: string;
    description: string;
    content: string;
    image?: string;
    features?: string[];
}

interface PlanDetailContentProps {
    plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <PlanIntroSection
                plan={plan}
                translationNamespace="planDetails.clickPlan.hero"
                imageSrc="/images/mlm-plans/click_animate.gif"
                descriptionKeys={['description1', 'description2']}
            />
            <WhatIsPlanSection plan={plan} />
            <HowItWorksSection plan={plan} />
            <WhatIsSoftwareSection 
                plan={plan} 
                translationNamespace="planDetails.clickPlan.whatIsSoftware"
                imageSrc="/images/mlm-plans/click_animate.gif"
            />
            <HowSoftwareWorksSection plan={plan} translationNamespace="planDetails.clickPlan.howSoftwareWorks" />
            <FeaturesSection plan={plan} translationNamespace="planDetails.clickPlan.features" />
            <CommissionsSection 
                plan={plan}
                translationNamespace="planDetails.clickPlan.commissions"
                commissions={[
                    { icon: TrendingUp, color: 'primary', titleKey: 'performance.title', descriptionKey: 'performance.description' },
                    { icon: Zap, color: 'blue', titleKey: 'quickStart.title', descriptionKey: 'quickStart.description' },
                    { icon: Layers, color: 'green', titleKey: 'level.title', descriptionKey: 'level.description' },
                    { icon: Award, color: 'purple', titleKey: 'director.title', descriptionKey: 'director.description' },
                    { icon: Users, color: 'orange', titleKey: 'sponsorMatching.title', descriptionKey: 'sponsorMatching.description' },
                    { icon: Crown, color: 'pink', titleKey: 'royalty.title', descriptionKey: 'royalty.description' },
                ]}
                gridCols="3"
                hasDescription={true}
            />
            <AdvantagesSection 
                plan={plan}
                translationNamespace="planDetails.clickPlan.advantages"
                advantageKeys={['advantage1', 'advantage2', 'advantage3', 'advantage4', 'advantage5', 'advantage6', 'advantage7', 'advantage8', 'advantage9']}
                gridCols="3"
                hasSummary={true}
            />
        </div>
    );
}

